import './App.css';
import './theme.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SinglePage from './pages/SinglePage';
import Navbar from './navbar';
import Footer from './footer';
import BusinessCard from './pages/BusinessCard';
import NotFound from './pages/NotFound';
// Business mode is disconnected (kept on disk for future revival). Site renders personal only.
import { ModeProvider } from './context/ModeContext';
import TerminalIntro from './components/TerminalIntro';
import DynoChat from './components/DynoChat';
import { useEffect, useState } from 'react';

function AppContent() {
  const [pulseClass, setPulseClass] = useState('');
  const [terminalDone, setTerminalDone] = useState(false);

  useEffect(() => {
    // Check if terminal was already shown this session
    if (sessionStorage.getItem('terminal-shown')) {
      setTerminalDone(true);
    }
  }, []);

  useEffect(() => {
    // Trigger color flow effect when mode changes
    setPulseClass('pulse-blue');

    // Remove pulse class after animation completes
    const timer = setTimeout(() => {
      setPulseClass('');
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const themeClass = 'personal-theme';

  return (
    <div className={`app-container ${pulseClass} ${themeClass}`}>
      {!terminalDone && (
        <TerminalIntro onComplete={() => setTerminalDone(true)} />
      )}
      <Router>
        <Navbar />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<SinglePage />} />
            {/* Legacy paths kept as redirects into the single page */}
            <Route path="/about" element={<SinglePage />} />
            <Route path="/experience" element={<SinglePage />} />
            <Route path="/projects" element={<SinglePage />} />
            <Route path="/hello" element={<BusinessCard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer/>
        {terminalDone && <DynoChat />}
      </Router>
    </div>
  );
}

function App() {
  return (
    <ModeProvider>
      <AppContent />
    </ModeProvider>
  );
}

export default App;
